import ShareButtons from './shareButtons'

const shareButtons = new ShareButtons()
shareButtons.init()
